import { IconWrapper } from '../runtime';
export default IconWrapper('lock', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M8 9.74985V11.2498M4.25 14.2498H11.75C12.5784 14.2498 13.25 13.5783 13.25 12.7498V8.24985C13.25 7.42142 12.5784 6.74985 11.75 6.74985H4.25C3.42157 6.74985 2.75 7.42142 2.75 8.24985V12.7498C2.75 13.5783 3.42157 14.2498 4.25 14.2498ZM11.25 6.74985V4.99985C11.25 3.20492 9.79493 1.74985 8 1.74985C6.20507 1.74985 4.75 3.20492 4.75 4.99985V6.74985H11.25Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});